// src/pages/NotarySearch.jsx
import React, { useState } from 'react';
import Navbar from '../components/LandingPage-main/Navbar';
import Footer from '../components/PlumPlusDash/Footer';

const NotarySearch = () => {
  const [location, setLocation] = useState('');
  const [results, setResults] = useState([]);

  const handleSearch = (e) => {
    e.preventDefault();
    // Simuler des résultats de recherche
    setResults([
      { name: 'Notaire Jean Dupont', address: '123 Rue Principale, Montréal' },
      { name: 'Notaire Marie Curie', address: '456 Avenue Québec, Québec' },
    ]);
  };

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <div className="flex-grow container mx-auto px-4 py-10">
        <h1 className="text-3xl font-bold mb-4 text-primary">Recherche de Notaire</h1>
        <p className="mb-6">Trouvez un notaire près de chez vous pour vos démarches officielles.</p>
        <form onSubmit={handleSearch} className="mb-6">
          <label htmlFor="location" className="block text-left mb-2 font-semibold">Ville ou Code Postal :</label>
          <input
            type="text"
            id="location"
            value={location}
            onChange={(e) => setLocation(e.target.value)}
            placeholder="Ex. Montréal, H2X 1Y4"
            required
            className="w-full p-3 border border-gray-300 rounded-lg mb-4"
          />
          <button type="submit" className="btn btn-accent w-full">Rechercher</button>
        </form>
        {results.length > 0 && (
          <div>
            <h2 className="text-2xl font-semibold mb-4">Résultats de Recherche</h2>
            <ul className="space-y-4">
              {results.map((notary, index) => (
                <li key={index} className="bg-white p-4 rounded-lg shadow">
                  <h3 className="text-xl font-bold">{notary.name}</h3>
                  <p className="text-gray-600">{notary.address}</p>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default NotarySearch;
